var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breadcrumbs = void 0;
var Breadcrumbs_1 = __importDefault(require("./Breadcrumbs"));
exports.Breadcrumbs = Breadcrumbs_1.default;
exports.default = Breadcrumbs_1.default;
//# sourceMappingURL=index.js.map